import { useMutation, useQuery } from '@tanstack/react-query';
import {
    createBillingPayLink,
    fetchBillingInvoice,
    fetchBillingInvoices,
    fetchBillingSummary
} from '../services/billing';

const SUMMARY_STALE_MS = 60 * 1000;
const INVOICES_STALE_MS = 60 * 1000;

/** Either bound may be null - the endpoint reads that as unbounded. */
export function useBillingSummary(from: string | null, to: string | null) {
    return useQuery({
        queryKey: ['billing', 'mine', 'summary', from, to],
        queryFn: () => fetchBillingSummary(from ?? undefined, to ?? undefined),
        staleTime: SUMMARY_STALE_MS
    });
}

// Full, non-paginated list — the invoices tab and the overview tab's
// attention banner both filter/aggregate this client-side, sharing one cache
// entry so opening Overview doesn't duplicate the Invoices tab's fetch.
export function useBillingInvoices() {
    return useQuery({
        queryKey: ['billing', 'mine', 'invoices'],
        queryFn: fetchBillingInvoices,
        staleTime: INVOICES_STALE_MS
    });
}

export function useBillingInvoice(invoiceId: string | null) {
    return useQuery({
        queryKey: ['billing', 'mine', 'invoices', invoiceId],
        queryFn: () => fetchBillingInvoice(invoiceId!),
        enabled: invoiceId !== null
    });
}

export function useCreateBillingPayLink() {
    return useMutation({
        mutationFn: (invoiceId: string) => createBillingPayLink(invoiceId)
    });
}
